var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Public-Notice",style:(_vm.NoticeStyle)},[_vm._v(" "+_vm._s(_vm.Notice)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }